import { splitParentSummary } from './splitParentSummary.js'
/* =========================================================================
 * THE CARD'S ACTIONS — Open, Art, Quote, Email, Win, on the card itself.
 * [Jarvis · Claude] 2026-10-26
 *
 * These were only reachable two taps deep (card → drawer → "Actions &
 * assignment" tab, where they rendered at 0×0 until the tab switched). Each
 * button calls the SAME handler the drawer's action console calls
 * (CommandCenter.jsx onCreateArt / onQuote / onCampaign / onSubmitWin), so
 * there is one flow per action, not two.
 *
 * A space that does not allow writes passes no handlers: then only "Open"
 * renders, and a line says why — never a greyed button with no reason.
 * ========================================================================= */
import styles from './boardControls.module.css'

const stop = (e) => e.stopPropagation()

export default function CardActions({ c, onOpen, actions = {} }) {
  const { onCreateArt, onQuote, onCampaign, onSubmitWin } = actions || {}
  const parent = splitParentSummary(c)
  const any = onCreateArt || onQuote || onCampaign || onSubmitWin
  return (
    <div className={styles.actions} onClick={stop} onKeyDown={stop}>
      {onOpen && (
        <button type="button" className={`${styles.act} ${styles.actOpen}`} onClick={() => onOpen(c)}>
          Open record
        </button>
      )}
      {!parent && onCreateArt && <button type="button" className={styles.act} onClick={() => onCreateArt(c)}>Art</button>}
      {!parent && onQuote && <button type="button" className={styles.act} onClick={() => onQuote(c)}>Quote</button>}
      {!parent && onCampaign && <button type="button" className={styles.act} onClick={() => onCampaign(c)}>Email</button>}
      {onSubmitWin && <button type="button" className={styles.act} onClick={() => onSubmitWin(c)}>{parent ? 'Review split results' : 'Review winner'}</button>}
      {!any && <span className={styles.actNote}>This space is read-only here. Open the record for its actions.</span>}
    </div>
  )
}
